import moment from 'moment'
import _ from 'lodash'
import { C_ADD_SITE_ALERT, C_HIDE_SITE_ALERT, C_SHOW_SITE_ALERT, C_REMOVE_SITE_ALERT, C_CLEAR_SITE_ALERTS } from '../utilities/mutation-types'

function hideSiteAlert (state, id) {
  const alert = _.find(state.alerts, o => (o.id === id))
  if (alert) {
    if (alert.timeoutHandle) {
      clearTimeout(alert.timeoutHandle)
      alert.timeoutHandle = null
    }

    alert.visible = false
  }
}

function removeSiteAlert (state, id) {
  const index = _.findIndex(state.alerts, o => (o.id === id))
  if (index > -1) {
    if (state.alerts[index].timeoutHandle) {
      clearTimeout(state.alerts[index].timeoutHandle)
      state.alerts[index].timeoutHandle = null
    }

    state.alerts.splice(index, 1)
  }
}

export default {
  state: {
    alerts: []
  },
  getters: {
    siteAlerts (state) {
      return state.alerts
    }
  },
  mutations: {
    /**
     * @param {object} state
     * @param {object} alert
     * @param {string} alert.message - can be text/html
     * @param {string} alert.type='error' - one of: 'error', 'warning', 'info', 'success'
     * @param {string} alert.id=undefined - id to set the alert entry to, if the id already exists, it is overwritten in the array, if undefined, an id is auto-generated
     * @param {number} alert.timeout=undefined - in milliseconds to hide after timeout countdown completes
     * @param {boolean} alert.transient=false - if true, the alert should delete itself if closed or times out, instead of the default behavior of hiding itself
     */
    [C_ADD_SITE_ALERT] (state, { message, type, id, timeout, transient }) {
      type = type || 'error'
      const date = `${moment().format(process.env.VUE_APP_DATE_FORMAT)} ${moment().format(process.env.VUE_APP_TIME_FORMAT)}`
      id = id || 'alert' + Date.now() + (Math.random() + '').split('.')[1]
      timeout = timeout === undefined ? 6000 : timeout
      const newAlert = { date, message, type, id, timeout, visible: true }

      if (timeout && timeout > 0) {
        newAlert.timeoutHandle = setTimeout(() => {
          if (transient) {
            removeSiteAlert(state, newAlert.id)
          } else {
            hideSiteAlert(state, newAlert.id)
          }
        }, timeout)
      }

      if (id) {
        const foundIndex = _.findIndex(state.alerts, o => (o.id === id))
        if (foundIndex > -1) {
          state.alerts[foundIndex] = newAlert
          return
        }
      }

      state.alerts.unshift(newAlert)
    },
    [C_HIDE_SITE_ALERT] (state, id) {
      if (!id) {
        throw new Error('No id provided to hide site alert')
      }

      hideSiteAlert(state, id)
    },
    [C_SHOW_SITE_ALERT] (state, id) {
      if (!id) {
        throw new Error('No id provided to hide site alert')
      }

      const alert = _.find(state.alerts, o => (o.id === id))

      if (alert) {
        if (alert.timeoutHandle) {
          clearTimeout(alert.timeoutHandle)
          alert.timeoutHandle = null
        }
        alert.visible = true
        alert.timeout = null
      }
    },
    [C_REMOVE_SITE_ALERT] (state, id) {
      if (!id) {
        throw new Error('No id provided to remove site alert')
      }

      removeSiteAlert(state, id)
    },
    [C_CLEAR_SITE_ALERTS] (state) {
      state.alerts.forEach((alert) => {
        if (alert.timeoutHandle) {
          clearTimeout(alert.timeoutHandle)
          alert.timeoutHandle = null
        }
      })

      state.alerts = []
    }
  }
}
